import * as React from "react";
import { cn } from "@/lib/utils";

/** 메모 입력 필드 최대 높이 — 초과하면 내부 스크롤 */
const MEMO_MAX_HEIGHT = "max-h-30";

interface MemoTextareaProps
  extends Omit<React.ComponentProps<"textarea">, "value" | "onChange" | "rows"> {
  value: string;
  onChange: (value: string) => void;
}

/**
 * 한 줄에서 시작해 내용에 맞춰 자라는 메모 입력 (최대 높이부터는 내부 스크롤).
 * 타이포·테두리는 쓰는 쪽이 className 으로 정한다.
 */
export function MemoTextarea({
  value,
  onChange,
  className,
  ...props
}: MemoTextareaProps) {
  const ref = React.useRef<HTMLTextAreaElement>(null);

  // 입력 중에도, 값이 밖에서 비워질 때도 높이를 다시 맞춘다
  React.useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      rows={1}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        "w-full min-w-0 resize-none overflow-y-auto rounded-lg px-3 py-2",
        MEMO_MAX_HEIGHT,
        "bg-static-white outline-none placeholder:text-labels-assistive",
        "disabled:cursor-not-allowed disabled:bg-fills-neutral disabled:text-labels-alternative",
        className,
      )}
      {...props}
    />
  );
}

MemoTextarea.displayName = "MemoTextarea";
